import { PageLoader } from '../../Page'
import { useRequestProfileContext } from '../RequestProfile.hooks'

function RequestProfileLoader() {
  const { isInitiated, isLoading, isPerformingAction } =
    useRequestProfileContext()

  return (isLoading || isPerformingAction) && isInitiated ? (
    <PageLoader />
  ) : null
}

export default RequestProfileLoader
